import { Component, Input } from '@angular/core';
import { BoardReleaseListResponse } from 'src/app/shared';

@Component({
  selector: 'app-releases-label',
  template: `
    <div class="custom-option mr-1 mb-1" *ngFor="let item of items">
      <span class="badge-label text-ellipsis">{{ item.name }}</span>
      <span
        class="material-icons btn-clear ng-value-icon"
        (click)="clear(item)"
      >
        clear
      </span>
    </div>
  `
})
export class ReleasesLabelComponent {
  @Input() items: BoardReleaseListResponse[];
  @Input() clear: (data: any) => void;
}

